import {FixedVTag} from "../../entities/FixedVTag";
import {FixedVTagService} from "../../services/FixedVTagService";
import {ExportModel} from "./ExportModel";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {NotificationService} from "../../services/NotificationService";

export class FixedExportModel extends ExportModel<FixedVTag>{
    static $inject = ['$q','FixedVTagService','CustomFieldNameService','NotificationService'];
    constructor($q:ng.IQService, fixedService:FixedVTagService, public cfnService:CustomFieldNameService, public notifyService:NotificationService){
        super($q, cfnService, fixedService, notifyService);
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs =
            [
                ['vTagID', 'V-Tag ID', 100],
                ['name', 'Name', 100],
                ['locationName', 'Location', 215],
                ['readerName', 'Reader Name', 150],
                ['vTagLastSeen', 'V-Tag Last Seen', 175],
                ['batteryLevel', 'Battery Level', 150],
                ['vTagX', 'V-Tag X', 110],
                ['vTagY', 'V-Tag Y', 110],
                ['vTagZ', 'V-Tag Z', 110]
            ]
        return this.$q.when();
    }
    getExportType(){
        return "FixedVTag";
    }
}
